
import React from 'react';
import styled from 'styled-components';

interface SeparatorProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const StyledSeparator = styled.div<{ $orientation: 'horizontal' | 'vertical' }>`
  background: ${props => props.theme.border};
  
  ${props => props.$orientation === 'horizontal' ? `
    height: 1px;
    width: 100%;
    margin: 16px 0;
  ` : `
    width: 1px;
    height: 100%;
    margin: 0 16px;
  `}
`;

export const Separator: React.FC<SeparatorProps> = ({ 
  orientation = 'horizontal', 
  className 
}) => {
  return (
    <StyledSeparator 
      $orientation={orientation} 
      className={className} 
    />
  );
};
